import { render, staticRenderFns } from "./MultiValueTable.vue?vue&type=template&id=5d22dc12&scoped=true&"
import script from "./MultiValueTable.vue?vue&type=script&lang=js&"
export * from "./MultiValueTable.vue?vue&type=script&lang=js&"
import style0 from "./MultiValueTable.vue?vue&type=style&index=0&id=5d22dc12&scoped=true&lang=css&"
import style1 from "./MultiValueTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d22dc12",
  null
  
)

export default component.exports